import { axInst } from "../../components/Service/Service";

// 1.
export const getJcServiceAnalysis = async (arnValue) => {
  const res = await axInst.post(
    `${process.env.REACT_APP_API_URL}jcServiceAnalysis`,
    { arn: arnValue }
  );
  return res.data.result;
};

// 2.
export const getJcServiceAnalysisBs6 = async (arnValue) => {
  const res = await axInst.post(
    `${process.env.REACT_APP_API_URL}jcServiceAnalysis_bs6`,
    { arn: arnValue }
  );
  return res.data.result;
};

// 3.
export const getjcServiceAnalysis_non_bs6 = async (arnValue) => {
  const res = await axInst.post(
    `${process.env.REACT_APP_API_URL}jcServiceAnalysis_non_bs6`,
    { arn: arnValue }
  );
  return res.data.result;
};

// 4.
export const getTotalJobcard = async (arnValue) => {
  const res = await axInst.post(
    `${process.env.REACT_APP_API_URL}TotalJobcard`,
    { arn: arnValue }
  );
  return res.data.result;
};

// 5.
export const getOpenJobcard = async (arnValue) => {
  const res = await axInst.post(`${process.env.REACT_APP_API_URL}OpenJobcard`, {
    arn: arnValue,
  });
  return res.data.result;
};

// 6.
export const getBandhuappJc = async (arnValue) => {
  const res = await axInst.post(`${process.env.REACT_APP_API_URL}bandhuappJc`, {
    arn: arnValue,
  });
  return res.data.result;
};

// 7.
export const getTotaljcBs6 = async (arnValue) => {
  const res = await axInst.post(`${process.env.REACT_APP_API_URL}totaljcBs6`, {
    arn: arnValue,
  });
  return res.data.result;
};

// 8.
export const getOpenJcBs6 = async (arnValue) => {
  const res = await axInst.post(`${process.env.REACT_APP_API_URL}openjcBs6`, {
    arn: arnValue,
  });
  return res.data.result;
};

// 9.
export const getClosedjcBs6 = async (arnValue) => {
  const res = await axInst.post(`${process.env.REACT_APP_API_URL}closedjcBs6`, {
    arn: arnValue,
  });
  return res.data.result;
};

// 10.
export const getTotalJcNonBs6 = async (arnValue) => {
  const res = await axInst.post(
    `${process.env.REACT_APP_API_URL}totaljcNonBs6`,
    { arn: arnValue }
  );
  return res.data.result;
};

// 11.
export const getOpenJcNonBs6 = async (arnValue) => {
  const res = await axInst.post(
    `${process.env.REACT_APP_API_URL}openjcNonBs6`,
    { arn: arnValue }
  );
  return res.data.result;
};

// 12.
export const getClosedJcNonBs6 = async (arnValue) => {
  const res = await axInst.post(
    `${process.env.REACT_APP_API_URL}closedjcNonBs6`,
    { arn: arnValue }
  );
  return res.data.result;
};

// 13.
export const getLastThreeDetailBox = async (arnValue) => {
  const res = await axInst.post(
    `${process.env.REACT_APP_API_URL}lastThreeDetailBox`,
    { arn: arnValue }
  );
  return res.data.result;
};

// 14.
export const getLastThreeDetailPopup = async (arnValue) => {
  const res = await axInst.post(
    `${process.env.REACT_APP_API_URL}lastThreeDetailPopup`,
    { arn: arnValue }
  );
  return res.data.result;
};

// 15.
export const getSparesSales = async (arnValue) => {
  const res = await axInst.post(`${process.env.REACT_APP_API_URL}sparesSales`, {
    arn: arnValue,
  });
  return res.data.result;
};

// 16.
export const getDEFConsumption = async (arnValue) => {
  const res = await axInst.post(
    `${process.env.REACT_APP_API_URL}DEFConsumption`,
    { arn: arnValue }
  );
  return res.data.result;
};

// 17.
export const getDefPfd = async (arnValue) => {
  const res = await axInst.post(`${process.env.REACT_APP_API_URL}defPfd`, {
    arn: arnValue,
  });
  return res.data.result;
};

// 18.
export const getStateWiseJc = async (arnValue) => {
  const res = await axInst.post(`${process.env.REACT_APP_API_URL}stateWiseJc`, {
    arn: arnValue,
  });
  return res.data.result;
};

// 19.
export const getLobWiseJcData = async (arnValue) => {
  const res = await axInst.post(
    `${process.env.REACT_APP_API_URL}lobWiseJcData`,
    { arn: arnValue }
  );
  return res.data.result;
};

// 20.
export const getStateListData = async (arnValue) => {
  const res = await axInst.post(
    `${process.env.REACT_APP_API_URL}stateListData`,
    { arn: arnValue }
  );
  return res.data.result;
};

// 21.
export const getPplData = async (arnValue) => {
  const res = await axInst.post(`${process.env.REACT_APP_API_URL}pplData`, {
    arn: arnValue,
  });
  return res.data.result;
};

// 22.
export const getPlData = async (arnValue) => {
  const res = await axInst.post(`${process.env.REACT_APP_API_URL}plData`, {
    arn: arnValue,
  });
  return res.data.result;
};

// 23.
export const getLobData = async (arnValue) => {
  const res = await axInst.post(`${process.env.REACT_APP_API_URL}lobData`, {
    arn: arnValue,
  });
  return res.data.result;
};

// 24.
export const getFsclYrData = async (arnValue) => {
  const res = await axInst.post(`${process.env.REACT_APP_API_URL}fsclYrData`, {
    arn: arnValue,
  });
  return res.data.result;
};
